import React from "react";

export const RightArrowIcon = () => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 15.9924L1.50382 17.4963L10 9.00008L1.50382 0.503906L0 2.00773L6.99235 9.00008L0 15.9924Z" fill="white"/>
    <path d="M10 15.9924L11.5038 17.4963L20 9.00008L11.5038 0.503906L10 2.00773L16.9924 9.00008L10 15.9924Z" fill="white"/>
  </svg>

);